export const FEATURES = {
  BACKGROUND: 'BG',
  ACCESSORIES: 'AC',
  EXTERIOR: 'EX',
  INTERIOR: 'IN',
  ROOF: 'RO',
  BACKGROUND_URL_PARAMS: 'bg',
  ROOF_URL_PARAMS: 'rf',
  COE: 'coe'
};
